/*
 * @Author: DT
 * @Date: 2023-02-13 11:00:59
 * @LastEditors: DT
 * @LastEditTime: 2023-02-23 14:13:08
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/app/yzg/group/group.js
 */
import { qrySelfChainsApi, qrySaleChainsApi } from "@/libs/api.js";
import { uleUrl, uleCdn } from "@/libs/common";
import bottomPop from "@/components/yzg/bottomPop.vue";
import shareButton from "@/components/yzg/shareButton.vue";
import countDown from "@/components/yzg/countDown.vue";
export default {
  name: "group",
  components: {
    bottomPop,
    shareButton,
    countDown,
  },
  data() {
    return {
      isShowBottom: false,
      myQuery: {
        orgId: "",
        pageIndex: 1,
        pageSize: 5,
        clientCallType: "H5",
      },
      myList: [],
      myListStatus: 0, // 列表状态 0-初始 1-有数据 2-无数据
      myListFinished: false,
      myListSurplus: 0, // 剩余个数
      helpQuery: {
        orgId: "",
        pageIndex: 1,
        pageSize: 10,
        clientCallType: "H5",
      },
      helpLoading: false,
      helpFinished: false,
      helpFinishedText: "加载中...",
      helpIsLoad: false,
      helpList: [],
      helpListStatus: 0, // 列表状态 0-初始 1-有数据 2-无数据
      orgId: "",
      currentId: null, // 当前活动id
      currentState: 0, // 当前活动状态
    };
  },

  mounted() {
    let _this = this;
    // 获取orgId
    if (_this.$browser().yzg) {
      window.dsBridge.call("getStoreUserOrgInfo", "", function(e) {
        // window.dsBridge.call("getUserOrgInfo", "", function(e) {
        const orgInfo = JSON.parse(e);
        _this.orgId =
          orgInfo.orgTown ||
          orgInfo.orgArea ||
          orgInfo.orgCity ||
          orgInfo.orgProvince ||
          "";
        console.log(orgInfo);
        console.log("_this.orgId===", _this.orgId);
        _this.myQuery.orgId = _this.orgId || "";
        _this.helpQuery.orgId = _this.orgId || "";
        window.dsBridge.register("refreshList", function(s) {
          _this.refreshList();
        });
        window.dsBridge.call("registRefreshWebNotification", {
          JSViewWillAppearFunctionName: "refreshList",
        });
        _this.initList();
      });
    } else {
      // _this.myQuery.orgId = "439459";
      _this.myQuery.orgId = "50442";
      _this.helpQuery.orgId = "50442";
      // _this.helpQuery.orgId = "439459";
      _this.initList();
    }
  },
  computed: {
    computingTime() {
      return function(date) {
        let n = this.$moment().diff(date, "hour");
        if (n < 24) {
          if (n == 0 || n < 0) {
            return `1小时前`;
          } else {
            return `${n}小时前`;
          }
        } else if (n >= 24 && n < 48) {
          return `昨天`;
        } else if (n >= 48 && n < 72) {
          return `前天`;
        } else {
          return this.$moment(date).format("YYYY/MM/DD");
        }
      };
    },
  },
  methods: {
    // 创建接龙
    handleCreateGroup() {
      console.log(this.$browser());
      if (this.$browser().ios) {
        console.log("ios跳转");
        window.location.href =
          "objc:ulemobile://action&&UleTogetherBuyCreatVC&hasxib|0#isModification|0";
      } else if (this.$browser().android) {
        window.location.href = "ulemobile://action&&ui.GroupPublishActivity";
      } else {
        this.$toast("请前往邮掌柜创建,谢谢!");
      }
    },
    handleGetId(item) {
      this.currentId = item.id;
      this.currentState = item.activityState;
      this.handleTogglePop(true, "bottom");
    },
    handleTogglePop(res) {
      this.isShowBottom = res;
    },
    // 更新我的发布
    refreashMyList() {
      console.log("有没有走这里");
      this.myList = [];
      this.myQuery.pageIndex = 1;
      this.myListFinished = false;
      this.myListStatus = 0;
      this.getMyList();
    },
    // 我发布的
    getMyList() {
      qrySelfChainsApi(this.myQuery)
        .then((res) => {
          if (res.returnCode == "0000" && res.data.result.length > 0) {
            this.myList = this.myList.concat(res.data.result);
            let myListTotalPages = Math.ceil(
              res.data.totalRecords / this.myQuery.pageSize
            );
            if (this.myQuery.pageIndex == myListTotalPages) {
              this.myListFinished = true;
            }
            this.myList.length > 0
              ? (this.myListStatus = 1)
              : (this.myListStatus = 2);
            // 剩余条数
            this.myListSurplus = res.data.totalRecords - this.myList.length;
            console.log("res.data.totalRecords", res.data.totalRecords);
            console.log("this.myList.length", this.myList.length);
            console.log("剩余条数", this.myListSurplus);
            this.myList.forEach((item) => {
              // 活动描述
              if (item.activityDesc) {
                item.activityDescList = JSON.parse(item.activityDesc);
              } else {
                item.activityDescList = [];
              }
              // 活动图片
              if (item.imgUrl) {
                item.imgList = item.imgUrl.split(",");
                if (item.imgList.length > 1) {
                  item.showMore = true;
                }
              } else {
                item.imgList = [];
                item.showMore = false;
              }
              item.lastTime = this.$moment(item.endTime)
                .diff(this.$moment())
                .toString();
              item.activityStartTime = this.$moment(item.startTime).format(
                "YYYY/MM/DD"
              );
              item.activityEndTime = this.$moment(item.endTime).format(
                "YYYY/MM/DD"
              );
              item.activityStateText = {
                0: "未发布",
                1: "未开始",
                2: "接龙中",
                3: "已结束",
              }[item.activityState];
              let currentDate = this.$moment(Date.now()).format(
                  "YYYYMMDDHHmmss"
                ), // 当前时间
                endDate = this.$moment(item.endTime).format("YYYYMMDDHHmmss"); // 活动结束时间
              currentDate > endDate
                ? (item.isOver = true)
                : (item.isOver = false);
            });
            console.log("myListFinished", this.myListFinished);
            console.log("myListStatus", this.myListStatus);
          } else {
            this.myListStatus = 2;
            this.myListFinished = true;
          }
        })
        .catch((res) => {
          this.myListStatus = 2;
          this.myListFinished = true;
        });
    },
    // 我帮卖的
    getHelpList() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      qrySaleChainsApi(this.helpQuery)
        .then((res) => {
          this.$toast.clear();
          this.helpLoading = false;
          this.helpFinished = false;
          if (res.returnCode === "0000") {
            if (res.data.result.length > 0) {
              this.helpListStatus = 1;
              let helpTotalPages = Math.ceil(
                res.data.totalRecords / this.helpQuery.pageSize
              );
              this.helpList = this.helpList.concat(res.data.result);
              this.helpList.forEach((item) => {
                // 活动描述
                if (item.activityDesc) {
                  item.activityDescList = JSON.parse(item.activityDesc);
                } else {
                  item.activityDescList = [];
                }
                // 活动图片
                if (item.imgUrl) {
                  item.imgList = item.imgUrl.split(",");
                  if (item.imgList.length > 1) {
                    item.showMore = true;
                  }
                } else {
                  item.imgList = [];
                  item.showMore = false;
                }
                item.lastTime = this.$moment(item.endTime)
                  .diff(this.$moment())
                  .toString();
                item.activityStartTime = this.$moment(item.startTime).format(
                  "YYYY/MM/DD"
                );
                item.activityEndTime = this.$moment(item.endTime).format(
                  "YYYY/MM/DD"
                );
                item.activityStateText = {
                  0: "未发布",
                  1: "未开始",
                  2: "接龙中",
                  3: "已结束",
                }[item.activityState];
                let currentDate = this.$moment(Date.now()).format(
                    "YYYYMMDDHHmmss"
                  ), // 当前时间
                  endDate = this.$moment(item.endTime).format("YYYYMMDDHHmmss"); // 活动结束时间
                currentDate > endDate
                  ? (item.isOver = true)
                  : (item.isOver = false);
              });
              if (this.helpQuery.pageIndex == helpTotalPages) {
                this.helpFinished = true;
                this.helpFinishedText = "我已到达底部, 暂无其他数据啦~~";
              } else {
                this.helpFinished = false;
                this.helpQuery.pageIndex++;
              }
            } else {
              this.helpListStatus = 2;
              this.helpFinished = true;
            }
          } else {
            this.helpListStatus = 2;
            this.helpFinished = true;
          }
        })
        .catch((res) => {
          this.helpListStatus = 2;
          this.helpFinished = true;
        });
    },
    initList() {
      console.log("my===inityzg", this.myQuery);
      console.log("help====inityzg", this.helpQuery);
      this.myListFinished = false;
      this.helpFinished = false;
      this.myList = [];
      this.helpList = [];
      this.myQuery.pageIndex = 1;
      this.helpQuery.pageIndex = 1;
      this.getMyList();
      this.getHelpList();
    },
    refreshList() {
      console.log('刷新')
      window.location.reload( true )
      // console.log("my===refresh", this.myQuery);
      // console.log("help===1refresh", this.helpQuery);
      // this.myListFinished = false;
      // this.helpFinished = false;
      // this.myList = [];
      // this.helpList = [];
      // this.myQuery.pageIndex = 1;
      // this.helpQuery.pageIndex = 1;
      // this.getMyList();
      // this.getHelpList();
    },
    // 更新接龙状态
    getStateCanOver(index) {
      this.myList[index].activityState = 3;
      this.myList[index].activityStateText = "已结束";
    },
    // 点击获取更多列表
    handleGetMoreList() {
      this.myQuery.pageIndex++;
      this.getMyList();
    },
    // 跳转接龙详情
    handleToDetail(item) {
      console.log(item);
      console.log(this.$browser());
      // 未发布
      if (item.activityState == "0") {
        if (this.$browser().ios) {
          window.location.href = `objc:ulemobile://action&&WebDetailViewController:0&&key:https@@//h5.${uleUrl()}/yxd/community/chains/chainsDetail/${
            item.activityId
          }?status=1`;
        } else if (this.$browser().android) {
          window.location.href = `ulemobile://action&&ui.MyBusinessWebView##load_url::https://h5.${uleUrl()}/yxd/community/chains/chainsDetail/${
            item.activityId
          }?status=1`;
        } else {
          this.toNext(`/chains/chainsDetail/${item.activityId}?status=1`);
        }
      } else {
        if (this.$browser().ios) {
          window.location.href = `objc:ulemobile://action&&WebDetailViewController:0&&key:https@@//h5.${uleUrl()}/yxd/community/chains/chainsDetail/${
            item.activityId
          }`;
        } else if (this.$browser().android) {
          window.location.href = `ulemobile://action&&ui.MyBusinessWebView##load_url::https://h5.${uleUrl()}/yxd/community/chains/chainsDetail/${
            item.activityId
          }`;
        } else {
          this.toNext(`/chains/chainsDetail/${item.activityId}`);
        }
      }
    },
    // 点击查看收益
    handleWatch(item) {
      if (this.$browser().ios) {
        window.location.href = `objc:ulemobile://action&&WebDetailViewController:0&&key:https@@//h5.${uleUrl()}/yxd/community/yzg/editGroup/${
          item.activityId
        }?isCheck=1`;
      } else if (this.$browser().android) {
        window.location.href = `ulemobile://action&&ui.MyBusinessWebView##load_url::https://h5.${uleUrl()}/yxd/community/yzg/editGroup/${
          item.activityId
        }?isCheck=1`;
      } else {
        this.toNext(`/yzg/editGroup/${item.activityId}?isCheck=1`);
      }
    },
  },
};
